export default "__VITE_ASSET__CSXFqRCP__"